const collectData = {
  CollectDataHeader: 'Voice data contribution',
  Send: 'Gửi',
  Skip: 'Bỏ qua',
  CollectDataInstruction: 'Hướng dẫn',
  CollectDataRecord: 'Ấn biểu tượng mi-cờ-rô để bắt đầu ghi âm (có thể ghi âm lại nhiều lần)',
  CollectDataScript: 'Đọc thành tiếng đoạn thoại hiển thị trong khung xanh',
  CollectDataSkip: 'Ấn "Bỏ Qua" để chọn đoạn thoại khác',
  CollectDataSend: 'Ấn "Gửi" để gửi đoạn ghi âm',
  CollectDataAcknowledgement: 'Chúng mình rất trân trọng đóng góp của bạn ❤',
  CollectDataCommitment: 'Chúng mình cam kết mọi dữ liệu thu thập được chỉ dùng cho mục đích nghiên cứu',
}

export default collectData;
